import { History } from 'history'
let currHistory: History = null

export const locationHistory = {
    get: () => {
        return currHistory
    },
    set:(route: History)=>{
        currHistory = route
    }
}



// WEBPACK FOOTER //
// ./src/services/history.tsx